export const investmentPageEn = {
  eyebrow: 'For investors & private wealth management',
  title: 'Financial & Strategic Proposal',
  subtitle:
    'Holol Real Estate Club is a multi-revenue international platform bringing together memberships, specialized services, auctions, media, exhibitions, and cross-border networks — with gradual expansion from 15 countries to 100 countries within five years.',
  heroStats: [
    { value: '$3.1B', label: 'Target annual revenue' },
    { value: '1.5M', label: 'Target members' },
    { value: '$150M', label: 'Required funding' },
    { value: '20%', label: "Investor's share" },
  ],
  video: {
    title: 'Overview for investors and private wealth management',
    placeholder: 'Video coming soon',
    videoUrl: "https://www.youtube.com/watch?v=2Ri5Psu2tyk",
    videoSrc: null,
  },
  overviewEyebrow: 'Strategic overview',
  overviewTitle: 'Platform, market, and opportunities',
  modelEyebrow: 'Business model',
  modelTitle: 'Membership & geographic reach',
  modelLead:
    'A tiered membership structure across 15 Phase 1 countries, designed to scale into a global network of 1.5 million members.',
  financialEyebrow: 'Financial model',
  financialTitle: 'Multiple revenue sources',
  termsEyebrow: 'Investment structure',
  termsTitle: 'Ownership, funding & execution',
  gate: {
    title: 'The full financial & strategic proposal',
    text:
      'Covering detailed revenue streams, ownership and funding terms, and the growth and expansion roadmap.',
    button: 'View the full proposal',
  },
  sections: [
    {
      icon: 'summarize',
      title: 'Executive Summary',
      paragraphs: [
        'Holol Real Estate Global Club is an international platform built on real estate memberships, specialized services, auctions and property exchange, media and sponsorships, and international exhibitions — all under one multi-revenue model.',
        'The project aims to build a cross-border institutional network connecting individuals, companies, institutions, government entities, and real estate service providers across multiple markets.',
      ],
    },
    {
      icon: 'hub',
      title: 'Who We Are',
      paragraphs: [
        'We are building a market influence and media platform, not merely a services company. Our goal is to open new markets, generate real opportunities, connect companies with the right clients, and turn visibility and reach into measurable economic value.',
        'The project operates through a digital platform, mobile app, partner network, central management, a strong media arm, and multi-country cooperation structures.',
      ],
    },
    {
      icon: 'visibility',
      title: 'Vision',
      paragraphs: [
        'To become the world\'s largest multi-country real estate club, connecting investors, individuals, companies, and elite clubs within one integrated operating model supported by media and international partnerships.',
      ],
    },
    {
      icon: 'diamond',
      title: 'What Makes the Project Different',
      paragraphs: ['The project stands on three core pillars:'],
      bullets: [
        'Media power — television programs, digital content, magazines, newspapers, conferences, exhibitions, and sponsorships.',
        'Broad reach — individuals, companies, institutions, government entities, banks, elite clubs, and decision-makers.',
        'International network — starting with 15 countries in Phase 1 and expanding gradually to 100 countries within five years.',
      ],
    },
    {
      icon: 'trending_up',
      title: 'Why Now',
      paragraphs: [
        'The global real estate market is undergoing a clear transformation in how clients are reached, brands are built, relationships are managed, and businesses are expanded.',
        'Success is no longer based solely on providing real estate services, but on a project\'s ability to combine platform, media, reach, networks, and cross-market integration.',
        'The current timing is also highly suitable for this type of project for several reasons:',
      ],
      bullets: [
        'Growing demand for integrated real estate solutions rather than fragmented services',
        'The increasing influence of digital and television media on purchasing and investment decisions',
        'Expansion of regional and international real estate markets',
        'Growing investor interest in multi-revenue platforms',
        'A clear market gap between traditional real estate companies and platforms that combine market power, media power, and network effects',
      ],
      closingParagraph:
        'Launching this project now is a strategic opportunity to secure a leadership position before this model becomes a general market trend.',
    },
    {
      icon: 'task_alt',
      title: 'What Has Been Achieved',
      bullets: [
        'Defining the overall vision of the project',
        'Establishing the multi-revenue model',
        'Developing the initial concept for the digital platform',
        'Preparing the structure for memberships, services, events, and media content',
        'Reaching an advanced stage of executive preparation',
        'Launching a promotional platform that has already generated engagement from a large number of interested companies',
        'Beginning development of the application and preparing an initial operational version',
        'Contacting a large number of companies, with several entities expressing initial interest in joining',
      ],
      closingParagraph:
        'This confirms that the project has genuinely moved from the idea stage into practical execution.',
    },
    {
      icon: 'groups',
      title: 'Initial Market Validation & Interest from Major Entities',
      paragraphs: [
        'The project has been preliminarily discussed with a number of experts and specialists in real estate development and related service sectors. The concept received a positive response and clear interest, given the expansion, media, and direct commercial value it offers.',
        'Several parties have expressed preliminary readiness to cooperate or participate once the project\'s operational and financial framework is complete — confirming initial market acceptance and the viability of moving into the execution phase.',
        'Early market engagement also confirmed that Holol Real Estate Club is not viewed as a traditional property sales venture, but as a platform that opens new markets for companies, delivers direct media and commercial value, and connects them with a wider audience of clients, institutions, and stakeholders.',
      ],
    },
  ],
  membership: {
    title: 'Membership tiers',
    headers: ['Tier', 'Annual fee', 'Share', 'Members'],
    rows: [
      ['Individual Membership', '$500', '85%', '1,275,000'],
      ['Pioneer Membership', '$1,500', '10%', '150,000'],
      ['Elite Membership', '$3,000', '5%', '75,000'],
    ],
    footer: ['Total target members', '', '', '1,500,000'],
  },
  geoDistribution: {
    title: 'Geographic distribution of members',
    headers: ['Country', 'Members'],
    rows: [
      ['Egypt', '220,000'],
      ['Saudi Arabia', '170,000'],
      ['UAE', '130,000'],
      ['United Kingdom', '140,000'],
      ['France', '110,000'],
      ['Germany', '110,000'],
      ['Italy', '100,000'],
      ['Spain', '100,000'],
      ['Turkey', '140,000'],
      ['Oman', '60,000'],
      ['Qatar', '50,000'],
      ['Singapore', '55,000'],
      ['Malaysia', '60,000'],
      ['Greece', '35,000'],
      ['Cyprus', '20,000'],
    ],
    footer: ['Total', '1,500,000'],
  },
  expansion: {
    title: 'International expansion stages',
    headers: ['Year', 'Target countries'],
    rows: [
      ['Year 1', '15 countries'],
      ['Year 2', '35 countries'],
      ['Year 3', '60 countries'],
      ['Year 4', '80 countries'],
      ['Year 5', '100 countries'],
    ],
    countriesNote:
      'Phase 1 countries: Italy, Greece, Egypt, Spain, United Kingdom, Saudi Arabia, Turkey, Germany, UAE, Singapore, Cyprus, Oman, Malaysia, France, Qatar.',
  },
  revenueTotal: {
    label: 'Total annual target revenue',
    value: '$3,109,550,000',
  },
  revenueStreams: [
    {
      title: 'Membership revenue',
      items: [
        { name: 'Individual members', amount: '$637,500,000' },
        { name: 'Pioneer members', amount: '$225,000,000' },
        { name: 'Elite members', amount: '$225,000,000' },
      ],
      totalLabel: 'Total',
      total: '$1,087,500,000',
    },
    {
      title: 'Service revenue',
      items: [
        { name: 'Real estate valuation', amount: '$11,250,000' },
        { name: 'Legal advisory services', amount: '$18,000,000' },
        { name: 'Real estate financing', amount: '$15,000,000' },
        { name: 'Property management', amount: '$18,000,000' },
        { name: 'Finishing and maintenance', amount: '$36,000,000' },
        { name: 'Accounting and tax services', amount: '$7,500,000' },
        { name: 'Residency, immigration & citizenship', amount: '$22,500,000' },
        { name: 'Sale / purchase / leasing services', amount: '$18,000,000' },
        { name: 'Investment partnerships', amount: '$15,000,000' },
      ],
      totalLabel: 'Total',
      total: '$161,250,000',
    },
    {
      title: 'Auctions & property exchange',
      items: [
        { name: 'Online auctions', amount: '$4,800,000' },
        { name: 'In-person auctions & exchange', amount: '$6,000,000' },
      ],
      totalLabel: 'Total',
      total: '$10,800,000',
    },
    {
      title: 'Television sponsorships',
      items: [
        { name: '500 sponsor companies', amount: '' },
        { name: 'Average sponsorship value', amount: '$1,000,000' },
      ],
      totalLabel: 'Total',
      total: '$500,000,000',
    },
    {
      title: 'International exhibitions',
      items: [
        { name: '12 annual exhibitions', amount: '' },
        { name: '750 participating companies', amount: '' },
        { name: 'Average participation fee', amount: '$150,000' },
      ],
      totalLabel: 'Total',
      total: '$1,350,000,000',
    },
  ],
  revenueSummary: {
    title: 'Annual revenue summary',
    headers: ['Source', 'Revenue'],
    rows: [
      ['Memberships', '$1,087,500,000'],
      ['Services', '$161,250,000'],
      ['Auctions and exchange', '$10,800,000'],
      ['Television sponsorships', '$500,000,000'],
      ['International exhibitions', '$1,350,000,000'],
    ],
    footer: ['Total annual target revenue', '$3,109,550,000'],
  },
  scenarios: {
    title: 'Target case vs conservative case',
    target: {
      title: 'Target case',
      intro: 'This is the scenario on which the core model is built:',
      bullets: [
        '1.5 million members in Phase 1',
        '1,500 companies across 15 countries',
        '500 sponsor companies',
        '12 international exhibitions annually',
        '10 TV programs',
        'Targeted annual revenue exceeding $3.1 billion',
      ],
    },
    conservative: {
      title: 'Conservative case',
      intro:
        'If only part of the plan is achieved in the first year, the project is still capable of generating very strong results.',
      highlight:
        'If only 10% to 15% of the annual target is achieved, revenues may still range between approximately $310 million and $465 million.',
      noteTitle: 'Important note',
      note:
        'This shows that the project combines great ambition with a realistic view of risk, and remains highly profitable even in the conservative scenario — capable of covering costs and generating attractive returns.',
    },
  },
  ownership: {
    title: 'Ownership structure',
    headers: ['Party', 'Ownership'],
    rows: [
      ['Founder', '80%'],
      ['Investor / investor group', '20%'],
    ],
    note:
      'The brand, the concept, and the core ecosystem are fully owned by the founder and may not be transferred except with his explicit written approval.',
  },
  profitPolicy: {
    title: 'Profit distribution policy',
    items: [
      { share: '10%', label: 'Operating reserve and return on investment' },
      { share: '40%', label: 'Management and operating share' },
      { share: '50%', label: 'Distributed to shareholders according to ownership shares' },
    ],
    note: 'The shareholder portion is distributed according to the agreed ownership structure.',
  },
  funding: {
    title: 'Funding requirements & capital call plan',
    lead:
      'The first phase of launching Holol Real Estate Club requires a funding commitment of no less than USD 150,000,000, to be drawn in three agreed tranches over a 6-month period.',
    body:
      'This ensures operational stability, covers core expenses, and enables the project to execute its media and operating plan without early cash-flow pressure. The funding will be used to develop the platform and application, launch media programs, establish Phase 1 countries, build partnerships, execute events and exhibitions, and maintain the operating reserve.',
    tranches: [
      { amount: '$50,000,000', label: 'First tranche at closing' },
      { amount: '$50,000,000', label: 'Second tranche after 90 days' },
      { amount: '$50,000,000', label: 'Third tranche after 180 days' },
    ],
  },
  capitalUse: {
    title: 'Planned use of the initial capital allocation (USD 50 million)',
    headers: ['Category', 'Amount', 'Share'],
    rows: [
      ['Platform, app, and systems development', '$7,000,000', '14%'],
      ['Media, television production, and digital content', '$12,000,000', '24%'],
      ['Launching the 15 countries and local operating teams', '$9,000,000', '18%'],
      ['Partnerships and commercial network building', '$6,000,000', '12%'],
      ['Legal structuring, governance, and intellectual property', '$3,000,000', '6%'],
      ['Exhibitions, events, and pilot sponsorships', '$7,000,000', '14%'],
      ['Operating reserve and contingency', '$6,000,000', '12%'],
    ],
    footer: ['Total funding (per tranche)', '$50,000,000', '100%'],
  },
  milestones: [
    {
      title: 'Phase 1 milestones',
      items: [
        'Establish the main legal entity',
        'Register the trademark and intellectual property rights',
        'Approve governance and management structure',
        'Launch the first version of the platform and app',
        'Appoint the core executive team',
        'Set up membership and payment systems',
        'Sign at least 10 initial MOUs',
        'Launch 3 pilot markets and 3 media/content partners',
        'Start selling memberships in pilot markets',
      ],
    },
    {
      title: 'Phase 2 milestones',
      items: [
        'Operate the platform and app in 5 to 8 countries',
        'Reach at least 150,000 paid members',
        'Sign 250 approved service companies',
        'Launch at least 2 media programs',
        'Execute 2 major exhibitions or events',
        'Generate first real operating revenues',
        'Activate referral and service systems',
        'Sign at least 20 sponsorship or commercial partnership agreements',
      ],
    },
    {
      title: 'Phase 3 milestones',
      items: [
        'Reach all 15 Phase 1 countries',
        'Reach 400,000 to 500,000 paid members',
        'Sign at least 600 approved companies',
        'Execute 6 to 12 international exhibitions',
        'Launch 10 active media programs or equivalent',
        'Achieve stable operating revenues',
        'Be ready for the next expansion phase',
      ],
    },
  ],
  exitPlan: {
    title: 'Exit plan',
    text:
      'The investor may exit through a share buyback, sale to a new investor, partial exit, or participation in a later round at a higher valuation — with a right of first refusal for the founder or existing shareholders, and a fair valuation mechanism that protects the company\'s stability.',
  },
  governance: {
    title: 'Governance',
    text:
      'The company will operate under a board of directors or steering committee, with periodic financial and operational reporting, approval of major decisions, clear separation of personal and company funds, and oversight of expenses and commitments.',
  },
  conclusion: {
    title: 'Investment conclusion',
    paragraphs: [
      'Holol Real Estate Club is not a traditional venture; it is a multi-revenue international platform built on memberships, services, auctions, media, exhibitions, and international networks.',
      'The project is offering a funding commitment of $150 million in three tranches in exchange for 20% equity, within a clear ownership structure, a defined profit distribution model, and a major international expansion opportunity.',
      'Current work includes completing the platform and app, building a list of partners and country representatives, signing initial MOUs within 90 days, and preparing for the transition to a final investment agreement.',
    ],
  },
};

export const investmentPageAr = {
  eyebrow: 'للمستثمرين وإدارات الثروات الخاصة',
  title: 'العرض المالي والاستراتيجي',
  subtitle:
    'نادي حلول العقاري منصة دولية متعددة الإيرادات تجمع العضويات والخدمات المتخصصة والمزادات والإعلام والمعارض والشبكات العابرة للحدود — مع توسع تدريجي من 15 دولة إلى 100 دولة خلال خمس سنوات.',
  heroStats: [
    { value: '$3.1 مليار', label: 'الإيراد السنوي المستهدف' },
    { value: '1.5 مليون', label: 'عدد الأعضاء المستهدف' },
    { value: '$150 مليون', label: 'التمويل المطلوب' },
    { value: '20%', label: 'حصة المستثمر' },
  ],
  video: {
    title: 'نظرة عامة للمستثمرين وإدارات الثروات الخاصة',
    placeholder: 'الفيديو قريبًا',
    videoUrl: "https://www.youtube.com/watch?v=WCLkBjX63_8",
    videoSrc: null,
  },
  overviewEyebrow: 'نظرة استراتيجية',
  overviewTitle: 'المنصة والسوق و الفرص',
  modelEyebrow: 'نموذج الأعمال',
  modelTitle: 'العضوية والانتشار الجغرافي',
  modelLead:
    'هيكل عضوية متدرج عبر 15 دولة في المرحلة الأولى، مصمم للتوسع إلى شبكة عالمية تضم 1.5 مليون عضو.',
  financialEyebrow: 'النموذج المالي',
  financialTitle: 'مصادر الإيرادات المتعددة',
  termsEyebrow: 'هيكل الاستثمار',
  termsTitle: 'الملكية والتمويل والتنفيذ',
  gate: {
    title: 'العرض المالي والاستراتيجي الكامل',
    text:
      'يتضمّن تفاصيل مصادر الإيرادات، وشروط الملكية والتمويل، وخطة النمو والتوسّع.',
    button: 'استعراض العرض كاملاً',
  },
  sections: [
    {
      icon: 'summarize',
      title: 'الملخص التنفيذي',
      paragraphs: [
        'نادي حلول العقاري العالمي منصة دولية مبنية على العضويات العقارية والخدمات المتخصصة والمزادات وتبادل العقارات والإعلام والرعايات والمعارض الدولية — ضمن نموذج متعدد الإيرادات.',
        'يهدف المشروع إلى بناء شبكة مؤسسية عابرة للحدود تربط الأفراد والشركات والمؤسسات والجهات الحكومية ومقدمي الخدمات العقارية عبر أسواق متعددة.',
      ],
    },
    {
      icon: 'hub',
      title: 'من نحن',
      paragraphs: [
        'نحن نبني منصة تأثير سوقي وإعلامي، وليس مجرد شركة خدمات. هدفنا فتح أسواق جديدة، وتوليد فرص حقيقية، وربط الشركات بالعملاء المناسبين، وتحويل الظهور والانتشار إلى قيمة اقتصادية قابلة للقياس.',
        'يعمل المشروع عبر منصة رقمية وتطبيق جوال وشبكة شركاء وإدارة مركزية وذراع إعلامية قوية وهياكل تعاون متعددة الدول.',
      ],
    },
    {
      icon: 'visibility',
      title: 'الرؤية',
      paragraphs: [
        'أن نصبح أكبر نادي عقاري متعدد الدول في العالم، يربط المستثمرين والأفراد والشركات والأندية النخبوية ضمن نموذج تشغيل متكامل مدعوم بالإعلام والشراكات الدولية.',
      ],
    },
    {
      icon: 'diamond',
      title: 'ما الذي يميز المشروع',
      paragraphs: ['يقوم المشروع على ثلاثة ركائز أساسية:'],
      bullets: [
        'القوة الإعلامية — برامج تلفزيونية ومحتوى رقمي ومجلات وصحف ومؤتمرات ومعارض ورعايات.',
        'انتشار واسع — أفراد وشركات ومؤسسات وجهات حكومية وبنوك وأندية نخبوية وصناع قرار.',
        'شبكة دولية — تبدأ من 15 دولة في المرحلة الأولى وتتوسع تدريجيًا إلى 100 دولة خلال خمس سنوات.',
      ],
    },
    {
      icon: 'trending_up',
      title: 'لماذا الآن',
      paragraphs: [
        'يشهد السوق العقاري العالمي تحولًا واضحًا في طريقة الوصول للعملاء وبناء العلامات وإدارة العلاقات وتوسيع الأعمال.',
        'لم يعد النجاح قائمًا فقط على تقديم خدمات عقارية، بل على قدرة المشروع على الجمع بين المنصة والإعلام والانتشار والشبكات والتكامل عبر الأسواق.',
          "كما أن التوقيت الحالي مناسب جدا لهذا النوع من المشاريع لعدة أسباب:"
      ],
      bullets: [
        'تزايد الطلب على حلول عقارية متكاملة بدل الخدمات المجزأة',
        'تأثير الإعلام الرقمي والتلفزيوني المتزايد على قرارات الشراء والاستثمار',
        'توسع الأسواق العقارية الإقليمية والدولية',
        'اهتمام المستثمرين بالمنصات متعددة الإيرادات',
        'فجوة سوقية واضحة بين الشركات العقارية التقليدية والمنصات التي تجمع قوة السوق والإعلام وتأثير الشبكة',
      ],
      closingParagraph:
        'إطلاق هذا المشروع الآن فرصة استراتيجية لاحتلال موقع قيادي قبل أن يصبح هذا النموذج اتجاهًا عامًا في السوق.',
    },
    {
      icon: 'task_alt',
      title: 'ما تم إنجازه',
      bullets: [
        'صياغة الرؤية العامة للمشروع',
        'وضع نموذج الإيرادات المتعددة',
        'تطوير المفهوم الأولي للمنصة الرقمية',
        'إعداد هيكل العضويات والخدمات والفعاليات والمحتوى الإعلامي',
        'الوصول إلى مرحلة متقدمة من التحضير التنفيذي',
        'إطلاق منصة ترويجية حققت تفاعلًا من عدد كبير من الشركات المهتمة',
        'البدء في تطوير التطبيق وإعداد نسخة تشغيلية أولية',
        'التواصل مع عدد كبير من الشركات، مع إبداء عدة جهات اهتمامًا مبدئيًا بالانضمام',
      ],
      closingParagraph: 'وهذا يؤكد أن المشروع انتقل فعليًا من مرحلة الفكرة إلى التنفيذ العملي.',
    },
    {
      icon: 'groups',
      title: 'التحقق السوقي الأولي و اهتمام الجهات الكبري',
      paragraphs: [
        'تمت مناقشة المشروع مبدنيا مع عدد من الخبراء والمتخصصين في قطاعات التطوير العقاري' +
        ' و الخدمات المرتبطة، و لاقت الفكرة استجابة إيجابية واهتماما واضحا، نظرا لما تقدمه من قيمة توسعية وإعالمية' +
        ' و تجارية مباشرة.',
        'وقد أبدى عدد من األطراف استعدادا مبدنيا للتعاون أو المشاركة عند اكتمال اإلطار التنفيذي والمالي للمشروع، بما\n' +
        'يؤكد وجود قبول سوقي أولي للفكرة و جدوى التحول إلى مرحلة التنفيذ.',
        'كما أن التفاعل الأولي من السوق أكد أن النادي العقاري لا يُنظر إليه كمشروع بيع عقاري تقليدي، بل كمنصة تفتح\n' +
        'أسواقًا  جديدة للشركات، وتمنحها قيمة إعالمية وتجارية مباشرة، وتربطها بجمهور أوسع من العملاء والجهات\n' +
        'والمؤسسات.',
      ],
    },
  ],
  membership: {
    title: 'فئات العضوية',
    headers: ['الفئة', 'الرسوم السنوية', 'النسبة', 'عدد الأعضاء'],
    rows: [
      ['العضوية الفردية', '$500', '85%', '1,275,000'],
      ['عضوية الرواد', '$1,500', '10%', '150,000'],
      ['العضوية النخبوية', '$3,000', '5%', '75,000'],
    ],
    footer: ['إجمالي الأعضاء المستهدف', '', '', '1,500,000'],
  },
  geoDistribution: {
    title: 'التوزيع الجغرافي للأعضاء',
    headers: ['الدولة', 'عدد الأعضاء'],
    rows: [
      ['مصر', '220,000'],
      ['السعودية', '170,000'],
      ['الإمارات', '130,000'],
      ['المملكة المتحدة', '140,000'],
      ['فرنسا', '110,000'],
      ['ألمانيا', '110,000'],
      ['إيطاليا', '100,000'],
      ['إسبانيا', '100,000'],
      ['تركيا', '140,000'],
      ['عُمان', '60,000'],
      ['قطر', '50,000'],
      ['سنغافورة', '55,000'],
      ['ماليزيا', '60,000'],
      ['اليونان', '35,000'],
      ['قبرص', '20,000'],
    ],
    footer: ['الإجمالي', '1,500,000'],
  },
  expansion: {
    title: 'مراحل التوسع الدولي',
    headers: ['السنة', 'عدد الدول المستهدف'],
    rows: [
      ['السنة الأولى', '15 دولة'],
      ['السنة الثانية', '35 دولة'],
      ['السنة الثالثة', '60 دولة'],
      ['السنة الرابعة', '80 دولة'],
      ['السنة الخامسة', '100 دولة'],
    ],
    countriesNote:
      'دول المرحلة الأولى: إيطاليا، اليونان، مصر، إسبانيا، المملكة المتحدة، السعودية، تركيا، ألمانيا، الإمارات، سنغافورة، قبرص، عُمان، ماليزيا، فرنسا، قطر.',
  },
  revenueTotal: {
    label: 'إجمالي الإيراد السنوي المستهدف',
    value: '$3,109,550,000',
  },
  revenueStreams: [
    {
      title: 'إيرادات العضويات',
      items: [
        { name: 'الأعضاء الأفراد', amount: '$637,500,000' },
        { name: 'أعضاء الرواد', amount: '$225,000,000' },
        { name: 'الأعضاء النخبويون', amount: '$225,000,000' },
      ],
      totalLabel: 'الإجمالي',
      total: '$1,087,500,000',
    },
    {
      title: 'إيرادات الخدمات',
      items: [
        { name: 'تقييم العقارات', amount: '$11,250,000' },
        { name: 'الاستشارات القانونية', amount: '$18,000,000' },
        { name: 'التمويل العقاري', amount: '$15,000,000' },
        { name: 'إدارة الأصول', amount: '$18,000,000' },
        { name: 'التشطيب والصيانة', amount: '$36,000,000' },
        { name: 'المحاسبة والضرائب', amount: '$7,500,000' },
        { name: 'الإقامة والهجرة والجنسية', amount: '$22,500,000' },
        { name: 'خدمات البيع والشراء والتأجير', amount: '$18,000,000' },
        { name: 'شراكات الاستثمار', amount: '$15,000,000' },
      ],
      totalLabel: 'الإجمالي',
      total: '$161,250,000',
    },
    {
      title: 'المزادات وتبادل العقارات',
      items: [
        { name: 'المزادات الإلكترونية', amount: '$4,800,000' },
        { name: 'المزادات الحضورية والتبادل', amount: '$6,000,000' },
      ],
      totalLabel: 'الإجمالي',
      total: '$10,800,000',
    },
    {
      title: 'الرعايات التلفزيونية',
      items: [
        { name: '500 شركة راعية', amount: '' },
        { name: 'متوسط قيمة الرعاية', amount: '$1,000,000' },
      ],
      totalLabel: 'الإجمالي',
      total: '$500,000,000',
    },
    {
      title: 'المعارض الدولية',
      items: [
        { name: '12 معرضًا سنويًا', amount: '' },
        { name: '750 شركة مشاركة', amount: '' },
        { name: 'متوسط رسوم المشاركة', amount: '$150,000' },
      ],
      totalLabel: 'الإجمالي',
      total: '$1,350,000,000',
    },
  ],
  revenueSummary: {
    title: 'ملخص الإيرادات السنوية',
    headers: ['المصدر', 'الإيراد'],
    rows: [
      ['العضويات', '$1,087,500,000'],
      ['الخدمات', '$161,250,000'],
      ['المزادات والتبادل', '$10,800,000'],
      ['الرعايات التلفزيونية', '$500,000,000'],
      ['المعارض الدولية', '$1,350,000,000'],
    ],
    footer: ['إجمالي الإيراد السنوي المستهدف', '$3,109,550,000'],
  },
  scenarios: {
    title: 'السيناريو المستهدف مقابل السيناريو المتحفظ',
    target: {
      title: 'السيناريو المستهدف',
      intro: 'هذا هو السيناريو الذي بُني عليه النموذج الأساسي:',
      bullets: [
        '1.5 مليون عضو في المرحلة الأولى',
        '1,500 شركة عبر 15 دولة',
        '500 شركة راعية',
        '12 معرضًا دوليًا سنويًا',
        '10 برامج تلفزيونية',
        'إيراد سنوي مستهدف يتجاوز 3.1 مليار دولار',
      ],
    },
    conservative: {
      title: 'السيناريو المتحفظ',
      intro:
        'حتى لو تحقق جزء فقط من الخطة في السنة الأولى، يظل المشروع قادرًا على تحقيق نتائج قوية جدًا.',
      highlight:
        'إذا تحقق فقط 10% إلى 15% من الهدف السنوي، قد تتراوح الإيرادات بين نحو 310 مليون و465 مليون دولار.',
      noteTitle: 'ملاحظة هامة',
      note:
        'وهذا يوضح أن المشروع يجمع بين طموح كبير ورؤية واقعية للمخاطر، ويظل مربحًا للغاية حتى في السيناريو المتحفظ — قادرًا على تغطية التكاليف وتحقيق عوائد جذابة.',
    },
  },
  ownership: {
    title: 'هيكل الملكية',
    headers: ['الطرف', 'الملكية'],
    rows: [
      ['المؤسس', '80%'],
      ['المستثمر / مجموعة المستثمرين', '20%'],
    ],
    note:
      'العلامة التجارية، والفكرة، والمنظومة الأساسية مملوكة للمؤسس بالكامل، ولا تنتقل إلا بموافقة مكتوبة وصريحة منه.',
  },
  profitPolicy: {
    title: 'سياسة توزيع الأرباح',
    items: [
      { share: '10%', label: 'احتياطي تشغيلي وعائد على الاستثمار' },
      { share: '40%', label: 'حصة الإدارة والتشغيل' },
      { share: '50%', label: 'توزيع على المساهمين وفق حصص الملكية' },
    ],
    note: 'تُوزع حصة المساهمين بناءً على هيكل الملكية المتفق عليه.',
  },
  funding: {
    title: 'متطلبات التمويل وخطة استدعاء رأس المال',
    lead:
      'تتطلب المرحلة الأولى لإطلاق نادي حلول العقاري التزامًا تمويليًا لا يقل عن 150,000,000 دولار أمريكي، يُسحب على ثلاث دفعات متفق عليها خلال 6 أشهر.',
    body:
      'وهذا يضمن الاستقرار التشغيلي ويغطي النفقات الأساسية ويمكّن المشروع من تنفيذ خطته الإعلامية والتشغيلية دون ضغط تدفق نقدي مبكر. يُستخدم التمويل في تطوير المنصة والتطبيق وإطلاق البرامج الإعلامية وإنشاء دول المرحلة الأولى وبناء الشراكات وتنفيذ الفعاليات والمعارض والاحتياطي التشغيلي.',
    tranches: [
      { amount: '$50,000,000', label: 'الدفعة الأولى عند الإغلاق' },
      { amount: '$50,000,000', label: 'الدفعة الثانية بعد 90 يومًا' },
      { amount: '$50,000,000', label: 'الدفعة الثالثة بعد 180 يومًا' },
    ],
  },
  capitalUse: {
    title: 'الاستخدام المخطط لضخ رأس المال الأولي (50 مليون دولار)',
    headers: ['البند', 'المبلغ', 'النسبة'],
    rows: [
      ['تطوير المنصة والتطبيق والأنظمة', '$7,000,000', '14%'],
      ['الإعلام وإنتاج التلفزيون والمحتوى الرقمي', '$12,000,000', '24%'],
      ['إطلاق الـ15 دولة والفرق التشغيلية المحلية', '$9,000,000', '18%'],
      ['الشراكات وبناء الشبكة التجارية', '$6,000,000', '12%'],
      ['الهيكلة القانونية والحوكمة وحقوق الملكية الفكرية', '$3,000,000', '6%'],
      ['المعارض والفعاليات والرعايات التجريبية', '$7,000,000', '14%'],
      ['الاحتياطي التشغيلي والطوارئ', '$6,000,000', '12%'],
    ],
    footer: ['إجمالي التمويل (لكل دفعة)', '$50,000,000', '100%'],
  },
  milestones: [
    {
      title: 'معالم المرحلة الأولى',
      items: [
        'تأسيس الكيان القانوني الرئيسي',
        'تسجيل العلامة التجارية وحقوق الملكية الفكرية',
        'اعتماد هيكل الحوكمة والإدارة',
        'إطلاق النسخة الأولى من المنصة والتطبيق',
        'تعيين الفريق التنفيذي الأساسي',
        'إعداد أنظمة العضوية والدفع',
        'توقيع 10 مذكرات تفاهم على الأقل',
        'إطلاق 3 أسواق تجريبية و3 شركاء إعلام/محتوى',
        'بدء بيع العضويات في الأسواق التجريبية',
      ],
    },
    {
      title: 'معالم المرحلة الثانية',
      items: [
        'تشغيل المنصة والتطبيق في 5 إلى 8 دول',
        'الوصول إلى 150,000 عضو مدفوع على الأقل',
        'توقيع 250 شركة خدمات معتمدة',
        'إطلاق برنامجين إعلاميين على الأقل',
        'تنفيذ معرضين أو فعاليتين كبيرتين',
        'تحقيق أول إيرادات تشغيلية فعلية',
        'تفعيل أنظمة الإحالة والخدمات',
        'توقيع 20 اتفاقية رعاية أو شراكة تجارية على الأقل',
      ],
    },
    {
      title: 'معالم المرحلة الثالثة',
      items: [
        'الوصول إلى جميع دول المرحلة الأولى الـ15',
        'الوصول إلى 400,000 – 500,000 عضو مدفوع',
        'توقيع 600 شركة معتمدة على الأقل',
        'تنفيذ 6 إلى 12 معرضًا دوليًا',
        'إطلاق 10 برامج إعلامية نشطة أو ما يعادلها',
        'تحقيق إيرادات تشغيلية مستقرة',
        'الاستعداد للمرحلة التالية من التوسع',
      ],
    },
  ],
  exitPlan: {
    title: 'خطة الخروج',
    text:
      'يجوز للمستثمر الخروج عبر إعادة شراء الحصص أو البيع لمستثمر جديد أو خروج جزئي أو المشاركة في جولة لاحقة بتقييم أعلى — مع حق أولوية للمؤسس أو المساهمين الحاليين وآلية تقييم عادلة تحمي استقرار الشركة.',
  },
  governance: {
    title: 'الحوكمة',
    text:
      'ستعمل الشركة تحت مجلس إدارة أو لجنة توجيهية، مع تقارير مالية وتشغيلية دورية واعتماد القرارات الكبرى وفصل واضح بين الأموال الشخصية وأموال الشركة وإشراف على النفقات والالتزامات.',
  },
  conclusion: {
    title: 'خلاصة الاستثمار',
    paragraphs: [
      'نادي حلول العقاري ليس مشروعًا تقليديًا؛ إنه منصة دولية متعددة الإيرادات مبنية على العضويات والخدمات والمزادات والإعلام والمعارض والشبكات الدولية.',
      'يقدم المشروع التزامًا تمويليًا بقيمة 150 مليون دولار على ثلاث دفعات مقابل 20% من حقوق الملكية، ضمن هيكل ملكية واضح ونموذج توزيع أرباح محدد وفرصة توسع دولية كبيرة.',
      'يشمل العمل الحالي إكمال المنصة والتطبيق وبناء قائمة الشركاء وممثلي الدول وتوقيع مذكرات تفاهم أولية خلال 90 يومًا والاستعداد للانتقال إلى اتفاقية استثمار نهائية.',
    ],
  },
};
